import type { ReactNode } from "react";

import { HaNResultListEmpty } from "./components/HaNResultListEmpty";
import { HaNResultListHeader } from "./components/HaNResultListHeader";
import { HaNResultListItem } from "./components/HaNResultListItem";
import { HaNResultListLoading } from "./components/HaNResultListLoading";

type HaNResultListCompound = typeof HaNResultListRoot & {
  Header: typeof HaNResultListHeader;
  Item: typeof HaNResultListItem;
  Empty: typeof HaNResultListEmpty;
  Loading: typeof HaNResultListLoading;
};

const HaNResultListRoot = ({ children }: { children: ReactNode }) => {
  return <ul className="flex flex-col gap-2 px-3 py-2">{children}</ul>;
};

/** A tab's results in the list: items that show what's hovered and selected, with the list's empty and loading states. */
export const HaNResultList: HaNResultListCompound = Object.assign(HaNResultListRoot, {
  Header: HaNResultListHeader,
  Item: HaNResultListItem,
  Empty: HaNResultListEmpty,
  Loading: HaNResultListLoading,
});
